import React from 'react';
import { useSelector } from 'react-redux';
import { useSocioeconomicChartsData } from '../../../../hooks/useSocioeconomicChartsData';
import { GenericChartCard } from '../../../../component/charts/genericChartCard';
import { ErrorState } from './errorState';
import {
  calculateWidthConsumptionGoods,
  generateTitleAndSource,
} from './socioeconomicDemographicCharts';
import nls from '../nls/pt-BR.json';

export const ConsumptionByGoods: React.FC = () => {
  const { errorFetchData } =
    useSelector((state: any) => state.socioeconomicDemographicState) || '';
  const { consumptionByGoodsFormattedData } = useSocioeconomicChartsData();
  return (
    <GenericChartCard
      title={generateTitleAndSource(
        nls.charts.consumptionByGoods.consumptionByGoods,
        nls.disclaimers.dataSourceIBGE2010
      )}
    >
      {errorFetchData?.consumptionByGoods ? (
        <ErrorState />
      ) : (
        <>
          <div className="legends-consumption">
            <div className="legend">
              <div
                className="shape-circle"
                style={{ backgroundColor: '#2D239A' }}
              ></div>
              <p>{nls.charts.consumptionByGoods.construction}</p>
            </div>
            <div className="legend">
              <div
                className="shape-circle"
                style={{ backgroundColor: '#DE6B05' }}
              ></div>
              <p>{nls.charts.consumptionByGoods.habitation}</p>
            </div>
          </div>
          <div className="consumption-graphs-container">
            <div className="construction">
              <div
                className="materials"
                style={{
                  height: `${consumptionByGoodsFormattedData?.constructionMaterials?.percentage}%`,
                  border: !consumptionByGoodsFormattedData
                    ?.constructionMaterials?.percentage
                    ? 'none'
                    : 'border: 1px solid #5C6269',
                  padding: !consumptionByGoodsFormattedData
                    ?.constructionMaterials?.percentage
                    ? '0px'
                    : '10px',
                }}
              >
                <span>
                  {consumptionByGoodsFormattedData?.constructionMaterials?.name}{' '}
                  <br />
                  {
                    consumptionByGoodsFormattedData?.constructionMaterials
                      ?.label
                  }
                </span>
              </div>
              <div
                className="maintenance"
                style={{
                  height: `${consumptionByGoodsFormattedData?.homeMaintenance?.percentage}%`,
                  border: !consumptionByGoodsFormattedData?.homeMaintenance
                    ?.percentage
                    ? 'none'
                    : 'border: 1px solid #5C6269',
                  padding: !consumptionByGoodsFormattedData?.homeMaintenance
                    ?.percentage
                    ? '0px'
                    : '10px',
                }}
              >
                <span>
                  {consumptionByGoodsFormattedData?.homeMaintenance?.name}
                  <br />
                  {consumptionByGoodsFormattedData?.homeMaintenance?.label}
                </span>
              </div>
            </div>
            <div className="habitation">
              <div className="materials-appliance-furniture-container">
                <div
                  className="dwelling"
                  style={{
                    height: `${consumptionByGoodsFormattedData?.dwelling?.percentage}%`,
                  }}
                >
                  <span>
                    {consumptionByGoodsFormattedData?.dwelling?.name}
                    <br />
                    {consumptionByGoodsFormattedData?.dwelling?.label}
                  </span>
                </div>
                <div
                  className="appliance-furniture-container"
                  style={{
                    height: `${
                      consumptionByGoodsFormattedData?.homeAppliances
                        ?.percentage +
                      consumptionByGoodsFormattedData?.homeFurniture?.percentage
                    }%`,
                  }}
                >
                  <div
                    className="appliance"
                    style={{
                      width: `${calculateWidthConsumptionGoods(
                        consumptionByGoodsFormattedData?.homeAppliances?.value,
                        consumptionByGoodsFormattedData?.homeFurniture?.value
                      )}%`,
                    }}
                  >
                    <span>
                      {consumptionByGoodsFormattedData?.homeAppliances?.name}
                      <br />
                      {consumptionByGoodsFormattedData?.homeAppliances?.label}
                    </span>
                  </div>
                  <div
                    className="furniture"
                    style={{
                      width: `${calculateWidthConsumptionGoods(
                        consumptionByGoodsFormattedData?.homeFurniture?.value,
                        consumptionByGoodsFormattedData?.homeAppliances?.value
                      )}%`,
                    }}
                  >
                    <span>
                      {consumptionByGoodsFormattedData?.homeFurniture?.name}
                      <br />
                      {consumptionByGoodsFormattedData?.homeFurniture?.label}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </GenericChartCard>
  );
};
